import { Component, OnInit } from '@angular/core';
import {AutorizacaoService} from "../services/autorizacao.service";
import {ConstantsService} from "../fidelidade/ConstantsService";

@Component({
  selector: 'app-tela-cadastro-produtos',
  templateUrl: './tela-cadastro-produtos.component.html',
  styleUrls: ['./tela-cadastro-produtos.component.scss']
})
export class TelaCadastroProdutosComponent implements OnInit {
  empresa;

  constructor(private constantsService: ConstantsService) {
    this.constantsService.empresa$.subscribe( data => this.empresa  = data  )
  }

  ngOnInit() {
  }

}
